module.exports = __webpack_public_path__ + "static/carousel-image-3-e8c52dd48adaf0c6ca4c6215587a2c03.jpg";